import { defineMessages } from 'react-intl.macro';

const labCardMessages = defineMessages({
    labsBtnLabel: {
        id: 'labCard.btn.label',
        defaultMessage: 'Manage Student Labs',
    },
    deactivateLab: {
        id: 'labCard.toggle.deactivate',
        defaultMessage: 'Deactivate lab {index}',
    },
    activateLab: {
        id: 'labCard.toggle.activate',
        defaultMessage: 'Activate lab {index}',
    },
});

export default labCardMessages;
